module.exports = __webpack_public_path__ + "img/logoWhite.855b4ec1.png";